// Static frames and clips under /images and /media keep fixed file names, so their URLs carry
// the build version. Page HTML is never cached, which makes every deploy pick up new media
// without waiting for the browser cache to expire.
export const ASSET_VERSION = __ASSET_VERSION__;

export function asset(path: string): string {
  return `${path}?v=${ASSET_VERSION}`;
}
